const env = {
  // The production Laravel application is hosted on secure.tillionx.com.
  // Use REACT_APP_API_BASE_URL in a local .env file to point at a different API.
  url: process.env.REACT_APP_API_BASE_URL || "https://secure.tillionx.com/api/v1",
};

export default env;
